import { isEmail } from 'class-validator';
export const optionalEmailUserItemValidator = {
  optional: c => {
    const emailIsRequired = c.get('users.requiredFields.email', true);
    return !emailIsRequired;
  },
  validate: value => {
    return isEmail(value) || 'Bitte geben Sie eine gültige E-Mail-Adresse an.';
  }
};
export const requireEmailIfUsernameIsNoEmailUserItemValidator = {
  enabled: c => {
    const usernameIsEmail = c.get('users.usernameIsEmail', false);
    return !usernameIsEmail;
  },
  validate: value => isEmail(value) || 'Bitte geben Sie eine gültige E-Mail-Adresse an.'
};